var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.12 2.11283L73.8889 11.3677C77.4182 12.024 79.7994 15.4264 79.2075 18.9671L73.1827 55.0013C72.6778 58.0214 70.1728 60.1667 67.2568 60.3249V61.8328C70.8913 61.6853 74.0298 59.0296 74.6574 55.2755L80.6822 19.2413C81.4108 14.8835 78.4801 10.696 74.1363 9.88827L24.3674 0.633366C20.0236 -0.1744 15.9116 2.70346 15.183 7.06124L13.2168 18.8212H14.7374L16.6577 7.33548C17.2497 3.79478 20.5907 1.45652 24.12 2.11283Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18.8032,
    width: 66.5092,
    height: 61.5116,
    rx: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9111 62.4097L16.9958 56.7519C18.8281 54.7104 21.9041 54.6999 23.7531 56.7238L26.6961 59.8912C28.6814 62.0274 31.9836 61.8731 33.7827 59.5615L41.1951 50.0523C43.3234 47.3198 47.2275 47.1515 49.5587 49.6875L56.4623 57.2009",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.97 40.3189C31.97 43.7138 29.3562 46.4704 26.1371 46.4704C22.9181 46.4704 20.3076 43.7138 20.3076 40.3189C20.3076 36.9241 22.9181 34.1675 26.1371 34.1675C29.3562 34.1675 31.97 36.9241 31.97 40.3189Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlbum);
export default __webpack_public_path__ + "static/media/no-album.3546a3853e1edc36f1c4d05988831b41.svg";
export { ForwardRef as ReactComponent };